/* ============================================================
   HEMP LIFE - mobile commerce behaviour (Gravity XL)

   Four additive features, each independent and each wrapped so a
   failure in one cannot take the others - or the page - down:

     1  stickyTop()   keeps the collection sort bar under the header
     2  stickyAtc()   a sticky Add to cart bar on the product page
     3  quickAdd()    a bottom-sheet variant picker from any card
     4  emptyCart()   somewhere to go from an empty cart drawer

   Nothing here replaces Shopify behaviour. The sticky bar forwards
   its tap to the real Add to cart button rather than running its
   own submit, so there is exactly one add-to-cart code path. Quick
   add posts to the standard /cart/add and hands the response to
   Dawn's own cart drawer renderer.

   NO requestAnimationFrame is used to reveal UI. Browsers suspend
   rAF in background and offscreen tabs, which would leave a sheet
   permanently stuck below the fold for anyone who opened it and
   switched away. A 16ms timeout gets the transition onto a second
   frame and keeps running everywhere.
   ============================================================ */
(function () {
  'use strict';

  var MOBILE = '(max-width: 749px)';
  var isMobile = function () { return window.matchMedia(MOBILE).matches; };
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  function money(cents) {
    try {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents, window.Shopify.money_format);
      }
    } catch (e) {}
    return '$' + (cents / 100).toFixed(2);
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* Any panel that owns the screen. The sticky bar must never sit on
     top of one of these. */
  function overlayOpen() {
    var cd = $('cart-drawer');
    if (cd && cd.classList.contains('active')) return true;
    if (document.body.classList.contains('overflow-hidden-mobile')) return true;
    if (document.body.classList.contains('hl-noscroll')) return true;
    return !!$('.menu-drawer-container details[open]');
  }

  /* ============================================================ 1  STICKY TOP
     The collection sort bar sticks to --hl-sticky-top. That has to be
     the header's height while the header is revealed and 0 while it
     is not, or the bar either hides under the header or floats. */
  function stickyTop() {
    var header = $('.section-header');
    if (!header) return;
    var last = null;
    var apply = function () {
      var stuck = header.classList.contains('shopify-section-header-sticky');
      var v = stuck && isMobile() ? Math.round(header.getBoundingClientRect().height) + 'px' : '0px';
      if (v !== last) {
        last = v;
        document.documentElement.style.setProperty('--hl-sticky-top', v);
      }
    };
    apply();
    new MutationObserver(apply).observe(header, { attributes: true, attributeFilter: ['class'] });
    window.addEventListener('resize', apply, { passive: true });
  }

  /* ============================================================ 2  STICKY ATC */
  function stickyAtc() {
    var main = $('main[data-template="product"]');
    if (!main) return;
    var info = $('.product__info-container', main);
    if (!info) return;
    var realBtn = $('.product-form__submit', info);
    if (!realBtn) return;

    var bar = document.createElement('div');
    bar.className = 'hl-satc';
    bar.innerHTML =
      '<span class="hl-satc__info">' +
        '<span class="hl-satc__name"></span>' +
        '<span class="hl-satc__price"></span>' +
      '</span>' +
      '<button type="button" class="hl-satc__btn"></button>';
    document.body.appendChild(bar);

    var nameEl = $('.hl-satc__name', bar);
    var priceEl = $('.hl-satc__price', bar);
    var btn = $('.hl-satc__btn', bar);

    var title = $('.product__title', info);
    nameEl.textContent = title ? title.textContent.trim() : '';

    /* Mirror rather than recompute: whatever Dawn renders for price
       and button state after a variant change is the truth. */
    function sync() {
      var priceNode = $('.price__container .price-item--sale, .price__container .price-item--regular', info);
      priceEl.textContent = priceNode ? priceNode.textContent.trim() : '';
      var label = realBtn.querySelector('span');
      btn.textContent = ((label ? label.textContent : realBtn.textContent) || '').trim() || 'Add to cart';
      btn.disabled = !!realBtn.disabled;
    }
    sync();

    var priceHost = $('.price', info) || info;
    new MutationObserver(sync).observe(priceHost, { childList: true, subtree: true, characterData: true });
    new MutationObserver(sync).observe(realBtn, { attributes: true, childList: true, subtree: true });

    btn.addEventListener('click', function () {
      /* Forward the tap. One add-to-cart path, one set of error
         handling, one analytics event. */
      realBtn.click();
    });

    var visible = false;
    function show(on) {
      if (on === visible) return;
      visible = on;
      bar.classList.toggle('is-on', on);
    }

    var io = new IntersectionObserver(function (entries) {
      var e = entries[0];
      /* Only once the real button has scrolled ABOVE the fold - not
         while it is still below it on first paint. */
      var passed = e.boundingClientRect.top < 0;
      show(!e.isIntersecting && passed && isMobile() && !overlayOpen());
    }, { threshold: 0, rootMargin: '0px 0px -20px 0px' });
    io.observe(realBtn);

    /* A drawer opening must hide the bar immediately, not on the next
       scroll tick. */
    var watch = function () { if (visible && overlayOpen()) show(false); };
    document.addEventListener('click', function () { setTimeout(watch, 60); }, true);
    document.addEventListener('keyup', function () { setTimeout(watch, 60); });
    window.addEventListener('resize', function () { if (!isMobile()) show(false); }, { passive: true });
  }

  /* ============================================================ 3  QUICK ADD */
  var qa = { root: null, product: null, chosen: [], qty: 1, opener: null };

  function qaBuild() {
    if (qa.root) return qa.root;
    var el = document.createElement('div');
    el.className = 'hl-qa';
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-modal', 'true');
    el.setAttribute('aria-label', 'Choose options');
    el.innerHTML =
      '<div class="hl-qa__veil" data-qa-close></div>' +
      '<div class="hl-qa__sheet">' +
        '<div class="hl-qa__head">' +
          '<img class="hl-qa__thumb" alt="" width="64" height="64">' +
          '<div class="hl-qa__titles">' +
            '<p class="hl-qa__name"></p>' +
            '<p class="hl-qa__price"></p>' +
          '</div>' +
          '<button type="button" class="hl-qa__close" data-qa-close aria-label="Close">' +
            '<svg viewBox="0 0 20 20" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true">' +
              '<path d="M5 5l10 10M15 5L5 15" stroke-linecap="round"/></svg>' +
          '</button>' +
        '</div>' +
        '<div class="hl-qa__body"></div>' +
        '<div class="hl-qa__foot">' +
          '<button type="button" class="hl-qa__submit">Add to cart</button>' +
          '<a class="hl-qa__link" href="#">View full details</a>' +
        '</div>' +
      '</div>';
    document.body.appendChild(el);

    el.addEventListener('click', function (e) {
      if (e.target.closest('[data-qa-close]')) qaClose();
    });
    $('.hl-qa__submit', el).addEventListener('click', qaSubmit);
    qa.root = el;
    return el;
  }

  function qaClose() {
    if (!qa.root) return;
    qa.root.classList.remove('is-in');
    document.body.classList.remove('hl-noscroll');
    setTimeout(function () {
      if (qa.root && !qa.root.classList.contains('is-in')) qa.root.classList.remove('is-open');
    }, 320);
    if (qa.opener) { try { qa.opener.focus(); } catch (e) {} }
  }

  /* The variant whose option values match every current choice. */
  function qaVariant() {
    if (!qa.product) return null;
    var found = null;
    qa.product.variants.forEach(function (v) {
      if (found) return;
      var ok = true;
      qa.chosen.forEach(function (val, i) { if (v.options[i] !== val) ok = false; });
      if (ok) found = v;
    });
    return found;
  }

  /* Is there ANY available variant with this value at this position,
     given the other choices? That is what greys a pill out. */
  function qaValueAvailable(index, value) {
    return qa.product.variants.some(function (v) {
      if (!v.available) return false;
      if (v.options[index] !== value) return false;
      for (var i = 0; i < qa.chosen.length; i++) {
        if (i !== index && qa.chosen[i] && v.options[i] !== qa.chosen[i]) return false;
      }
      return true;
    });
  }

  function qaRender() {
    var p = qa.product;
    var root = qa.root;
    var body = $('.hl-qa__body', root);
    var v = qaVariant();

    $('.hl-qa__name', root).textContent = p.title;
    var img = $('.hl-qa__thumb', root);
    var src = (v && v.featured_image && v.featured_image.src) || p.featured_image || '';
    if (src) {
      var u = String(src);
      if (u.indexOf('//') === 0) u = 'https:' + u;
      img.src = u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=200';
      img.hidden = false;
    } else {
      img.hidden = true;
    }

    var priceHtml = v ? money(v.price) : money(p.price);
    if (v && v.compare_at_price && v.compare_at_price > v.price) {
      priceHtml += '<span class="hl-qa__was">' + money(v.compare_at_price) + '</span>';
    }
    $('.hl-qa__price', root).innerHTML = priceHtml;
    $('.hl-qa__link', root).href = p.url;

    var html = '';
    p.options.forEach(function (o, i) {
      var name = (o.name || o).toString();
      var values = o.values || [];
      /* A product whose only option is Shopify's placeholder "Title"
         has nothing to choose - do not invent a control for it. */
      if (name.toLowerCase() === 'title') return;
      html += '<div class="hl-qa__group">' +
        '<span class="hl-qa__label">' + esc(name) + ' <i>' + esc(qa.chosen[i] || '') + '</i></span>' +
        '<div class="hl-qa__opts" role="group" aria-label="' + esc(name) + '">' +
          values.map(function (val) {
            var on = qa.chosen[i] === val;
            var ok = qaValueAvailable(i, val);
            return '<button type="button" class="hl-qa__opt" data-qa-opt="' + i + '" data-qa-val="' + esc(val) + '"' +
              ' aria-pressed="' + (on ? 'true' : 'false') + '"' + (ok ? '' : ' disabled') + '>' + esc(val) + '</button>';
          }).join('') +
        '</div></div>';
    });

    html += '<div class="hl-qa__group"><span class="hl-qa__label">Quantity</span>' +
      '<div class="hl-qa__qty">' +
        '<button type="button" class="hl-qa__step" data-qa-qty="-1" aria-label="Decrease quantity">&minus;</button>' +
        '<span class="hl-qa__count" aria-live="polite">' + qa.qty + '</span>' +
        '<button type="button" class="hl-qa__step" data-qa-qty="1" aria-label="Increase quantity">+</button>' +
      '</div></div>' +
      '<p class="hl-qa__err" hidden></p>';

    body.innerHTML = html;

    var submit = $('.hl-qa__submit', root);
    if (!v) { submit.disabled = true; submit.textContent = 'Choose an option'; }
    else if (!v.available) { submit.disabled = true; submit.textContent = 'Sold out'; }
    else { submit.disabled = false; submit.textContent = 'Add to cart · ' + money(v.price * qa.qty); }

    body.onclick = function (e) {
      var opt = e.target.closest('[data-qa-opt]');
      if (opt && !opt.disabled) {
        qa.chosen[parseInt(opt.getAttribute('data-qa-opt'), 10)] = opt.getAttribute('data-qa-val');
        qaRender();
        return;
      }
      var step = e.target.closest('[data-qa-qty]');
      if (step) {
        qa.qty = Math.max(1, qa.qty + parseInt(step.getAttribute('data-qa-qty'), 10));
        qaRender();
      }
    };
  }

  function qaOpen(url, opener) {
    qa.opener = opener || null;
    var root = qaBuild();
    root.classList.add('is-open');
    $('.hl-qa__body', root).innerHTML = '<p class="hl-qa__label">Loading…</p>';
    setTimeout(function () { root.classList.add('is-in'); }, 16);
    document.body.classList.add('hl-noscroll');

    fetch(url.split('?')[0] + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(r.status); })
      .then(function (p) {
        qa.product = p;
        qa.qty = 1;
        /* Start from the variant Shopify would have selected, so the
           sheet opens on something real rather than empty. */
        var first = p.variants.filter(function (v) { return v.available; })[0] || p.variants[0];
        qa.chosen = first ? first.options.slice() : [];
        qaRender();
        var firstOpt = $('.hl-qa__opt:not([disabled])', qa.root);
        if (firstOpt) { try { firstOpt.focus(); } catch (e) {} }
      })
      .catch(function () {
        /* Never trap the shopper in a broken sheet. */
        qaClose();
        window.location.href = url;
      });
  }

  function qaSubmit() {
    var v = qaVariant();
    if (!v || !v.available) return;
    var btn = $('.hl-qa__submit', qa.root);
    var err = $('.hl-qa__err', qa.root);
    btn.disabled = true;
    btn.textContent = 'Adding…';
    if (err) err.hidden = true;

    var cart = $('cart-drawer');
    var body = { items: [{ id: v.id, quantity: qa.qty }] };
    try {
      if (cart && typeof cart.getSectionsToRender === 'function') {
        body.sections = cart.getSectionsToRender().map(function (s) { return s.section || s.id; });
        body.sections_url = window.location.pathname;
      }
    } catch (e) {}

    fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) {
          btn.disabled = false;
          btn.textContent = 'Add to cart';
          if (err) { err.hidden = false; err.textContent = (res.j && (res.j.description || res.j.message)) || 'Could not add that just now.'; }
          return;
        }
        qaClose();
        try {
          if (cart && typeof cart.renderContents === 'function') {
            cart.renderContents(res.j);
          } else {
            document.dispatchEvent(new CustomEvent('cart:refresh'));
          }
          if (cart && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
          if (cart && typeof cart.open === 'function') cart.open();
        } catch (e2) {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        }
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = 'Add to cart';
        if (err) { err.hidden = false; err.textContent = 'Could not add that just now.'; }
      });
  }

  function quickAdd() {
    document.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target.closest('[data-hl-quickadd]') : null;
      if (!t) return;
      var url = t.getAttribute('data-product-url');
      if (!url) return;
      e.preventDefault();
      qaOpen(url, t);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && qa.root && qa.root.classList.contains('is-in')) qaClose();
    });
  }

  /* ============================================================ 4  EMPTY CART
     Links are read from the site navigation rather than written here,
     so they can never drift from the real collections. Plain string
     matching rather than a regex - this file is written into Liquid
     via a GraphQL block string, where a backslash is a literal, and
     an escaped regex silently stops matching. */
  function emptyCart() {
    var drawer = $('cart-drawer');
    if (!drawer) return;

    function fill() {
      if (!drawer.classList.contains('is-empty')) return;
      var host = $('.drawer__inner-empty', drawer) || $('.cart__empty-text', drawer);
      if (!host || $('.hl-emptylinks', drawer)) return;

      var seen = {};
      var links = $$('.menu-drawer a[href*="/collections/"], .header__inline-menu a[href*="/collections/"]')
        .filter(function (a) {
          var h = a.getAttribute('href');
          if (!h) return false;
          if (seen[h]) return false;
          if (h.indexOf('/collections/all') > -1) return false;
          seen[h] = 1;
          return (a.textContent || '').trim().length > 0;
        })
        .slice(0, 4);
      if (links.length < 2) return;

      var html = '<div class="hl-emptylinks">' + links.map(function (a) {
        return '<a href="' + esc(a.getAttribute('href')) + '">' + esc(a.textContent.trim()) + '</a>';
      }).join('') + '</div>';

      var anchor = $('.cart__empty-text', drawer) || host;
      anchor.insertAdjacentHTML('afterend', html);
    }

    fill();
    new MutationObserver(function () { try { fill(); } catch (e) {} })
      .observe(drawer, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
  }

  function boot() {
    [stickyTop, stickyAtc, quickAdd, emptyCart].forEach(function (fn) {
      try { fn(); } catch (e) { /* one feature failing is not the page failing */ }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function () {
    try { stickyTop(); } catch (e) {}
  });
})();